<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="bg-white">
    <div class="">
      <ul role="list" class="grid grid-cols-1 gap-4 lg:grid-cols-3 font-gotham-bold">
        <li class="group col-span-1 flex shadow-sm rounded-2xl cursor-pointer">
          <div
            @click="handleClickAddVoipProduct"
            class="transition duration-250 border-solid"
            :class="[(voipProductAdded ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-xl transition duration-250 text-black" :class="[voipProductAdded ? 'text-black' : 'text-black']">Yes</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
              <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none" :class="[ voipProductAdded ? 'text-black' : 'text-black' ]">
                <CheckCircleIcon v-if="voipProductAdded" class="w-10 h-10" aria-hidden="true" />
              </button>
            </div>
          </div>
        </li>
        <li class="group col-span-1 flex shadow-sm rounded-2xl cursor-pointer">
          <div
            @click="handleClickRemoveVoipProduct"
            class="transition duration-250 border-solid"
            :class="[(!voipProductAdded ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-xl transition duration-250 text-black" :class="[ !voipProductAdded ? 'text-black' : 'text-black' ]">No</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
              <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none"
                :class="[ !voipProductAdded ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
                <CheckCircleIcon v-if="!voipProductAdded" class="w-10 h-10" aria-hidden="true" />
              </button>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="voipProductAdded">
        <h2 class="mt-6 text-brand-secondary text-md font-gotham-medium uppercase tracking-wide">Select a Voip Product</h2>
        <div class="mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4">
          <VoipSelectorProduct
            v-for="product in products"
            @handle-select-product="handleSelectProduct"
            :product="product"
            :key="product.name"
            :isSelectedProduct="isSelectedProduct(product)"
          />
        </div>
      </div>
      <div v-if="voipProductAdded">
        <h2 class="mt-6 text-brand-secondary text-md font-gotham-medium uppercase tracking-wide">Voip Home Number Listed Or Listed?</h2>
        <ul role="list" class="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3">
          <li class="group col-span-1 flex shadow-sm rounded-2xl cursor-pointer font-gotham-medium">
            <div
              @click="handleClickListedVoipProduct"
              class="transition duration-250 border-solid"
              :class="[(voipListedNumber ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]"
              >
              <div class="flex-1 px-8 py-2 text-lg truncate">
                <p class="text-xl transition duration-250 text-black" :class="[voipListedNumber ? 'text-black' : 'text-black']">Listed</p>
              </div>
              <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
                <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none" :class="[ voipListedNumber ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]">
                  <CheckCircleIcon v-if="voipListedNumber" class="w-10 h-10" aria-hidden="true" />
                </button>
              </div>
            </div>
          </li>
          <li class="group col-span-1 flex shadow-sm rounded-2xl cursor-pointer font-gotham-medium">
            <div
              @click="handleClickUnlistedVoipProduct"
              class="transition duration-250 border-solid"
              :class="[(!voipListedNumber ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]"
              >
              <div class="flex-1 px-8 py-2 text-lg truncate">
                <p class="text-xl transition duration-250 text-black" :class="[ !voipListedNumber ? 'text-black' : 'text-black' ]">Unlisted</p>
              </div>
              <div class="flex-shrink-0 pl-4 pr-4 flex items-center justify-center">
                <button type="button" class="w-10 h-10 bg-white inline-flex items-center justify-center rounded-full bg-transparent border-none"
                  :class="[ !voipListedNumber ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                  >
                  <CheckCircleIcon v-if="!voipListedNumber" class="w-10 h-10" aria-hidden="true" />
                </button>
              </div>
            </div>
          </li>
        </ul>
        <p class="text-base font-gotham-medium font-extralight mt-4 p-4 border">
          Your number will be set as unlisted by default but will be registered in the IPND database for emergency services.
          This can be changed at any time by contacting our friendly Australian-based support team on
          <a class="text-blue-500 hover:text-blue-800 hover:underline transition duration-250" target="_blank" :href="'mailto:' + voipInformation.email">{{ voipInformation.email }}</a>
          or <a  class="text-blue-500 hover:text-blue-800 hover:underline transition duration-250" target="_blank" :href="'tel:' + voipInformation.phone">{{ voipInformation.phone }}</a>. More information on IPND Policy can be found
          <a :href="voipInformation.csaAgreementUrl" target="_blank" class="text-blue-500 hover:text-blue-800 hover:underline transition duration-250">here.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>

import { defineProps, defineEmits, ref } from 'vue';
import VoipSelectorProduct from './VoipSelectorProductOld.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const voipInformation = brandService.getVoipInformation();

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}

const props = defineProps<{
  products: Array<Product>,
  isVoipAdded: boolean,
  isVoipListed: boolean,
  selected: string
}>();

const emit = defineEmits<{(e: 'onPlanSelected', id: string): void, (e: 'onVoipToggled', isVoipAdded: boolean): void, (e: 'onListingStatusToggled', isVoipListed: boolean): void}>();

const voipProductAdded = ref(false);
const voipListedNumber = ref(false);
const productSelected = ref<Product|null>();

const handleClickAddVoipProduct = () => {
  voipProductAdded.value = true;
  emit('onVoipToggled', true);
};

const handleClickRemoveVoipProduct = () => {
  voipProductAdded.value = false;
  emit('onVoipToggled', false);
};

const handleClickListedVoipProduct = () => {
  voipListedNumber.value = true;
  emit('onListingStatusToggled', true);
};

const handleClickUnlistedVoipProduct = () => {
  voipListedNumber.value = false;
  emit('onListingStatusToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onPlanSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};

</script>
